/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u1m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How long should a plank hold be for a beginner?`)
};

const es_timer_u1m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuánto debería durar una plancha para un principiante?`)
};

const de_timer_u1m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie lange sollte ein Unterarmstütz für Anfänger dauern?`)
};

const nl_timer_u1m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe lang moet een plank-hold zijn voor een beginner?`)
};

const fr_timer_u1m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien de temps un débutant devrait-il tenir une planche ?`)
};

const it_timer_u1m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto dovrebbe durare un plank per un principiante?`)
};

const pt_br2_timer_u1m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto tempo um iniciante deve segurar uma prancha?`)
};

const pt_timer_u1m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto tempo deve durar uma prancha para um principiante?`)
};

const ja_timer_u1m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`初心者のプランクはどのくらいの時間保持すればいいですか？`)
};

const zh_timer_u1m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`初学者的平板支撑应该保持多久？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u1m_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u1m_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u1m_faq3_q", locale)
	if (locale === "en") return en_timer_u1m_faq3_q(inputs)
	if (locale === "es") return es_timer_u1m_faq3_q(inputs)
	if (locale === "de") return de_timer_u1m_faq3_q(inputs)
	if (locale === "nl") return nl_timer_u1m_faq3_q(inputs)
	if (locale === "fr") return fr_timer_u1m_faq3_q(inputs)
	if (locale === "it") return it_timer_u1m_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u1m_faq3_q(inputs)
	if (locale === "pt") return pt_timer_u1m_faq3_q(inputs)
	if (locale === "ja") return ja_timer_u1m_faq3_q(inputs)
	return zh_timer_u1m_faq3_q(inputs)
};